export enum Theme {
  Dark = 'dark',
  Light = 'light',
}

export interface ColorTheme {
  // Header
  logoHorizontal: string
  naviText: string
  noticeLineColor: string
  footerBg: string
  footerColorText: string
  naviDropdownIcon: string
  btnBgRound: string

  // Idea List Page
  myTitleBg: string
  myTitleBorder: string
  fillStrategyBackground: string
  colorLongBg: string
  colorShortBg: string
  colorLong: string
  colorShort: string
  colorLongBorder: string
  colorShortBorder: string
  breachBackground: string
  remainingColor: string

  // Customize
  colorBorder: string
  colorBorderSecondary: string
  sumCardOutline: string
  sumCardBg: string
  sumCardBoxShadow: string
  sumText: string
  contentGold: string
  colorSplit: string
  colorBgContainerDisabled: string
  btnBgDefault: string
  colorIcon: string

  // Text Color
  colorSecondaryText: string
  colorTertiaryText: string

  // AntD Default
  colorText: string

  colorFill: string
  colorFillSecondary: string
  colorFillTertiary: string
  colorFillQuaternary: string
  defaultBorderColor: string

  bookNameLink: string
  disabledBookName: string

  agGridTableGreen: string
  agGridTableRed: string
  colorInfoBg: string
  colorInfo: string
  colorWarning: string
  colorWarningBg: string
  colorError: string

  // Echarts
  gaugeText: string
  colorDisableBg: string

  // Customize AntD
  colorPrimary: string
  colorPrimaryBg: string
  colorPrimaryBgHover: string
  colorPrimaryBorder: string
  colorPrimaryBorderGold: string
  colorPrimaryBorderHover: string
  colorPrimaryHover: string
  colorPrimaryActive: string
  colorPrimaryTextHover: string
  colorPrimaryText: string
  colorPrimaryTextActive: string
  colorTextDisabled: string
  colorGhostBg: string
  colorBWBg: string
  colorBWBgHover: string
  colorBWText: string
  colorBWTextHover: string

  // Custom Components
  createIdeaBgColor: string
  createIdeaTextColor: string
  createIdeaBorderColor: string

  // Common
  contentBg: string

  borderRadiusXS: string
  borderRadiusXSCompact: string
  borderRadiusSM: string
  borderRadiusSMCompact: string
  borderRadiusBase: string
  borderRadiusLG: string
  borderRadiusLGCompact: string

  // Size
  sizeXXS: string
  sizeXS: string
  sizeSM: string
  sizeBase: string
  sizeMD: string
  sizeLG: string
  sizeXL: string
  sizeXXL: string

  // Height
  controlHeightXS: string
  controlHeightSM: string
  controlHeight: string
  controlHeightLG: string

  // Screen size
  screenXS: string
  screenSM: string
  screenMD: string
  screenLG: string
  screenXL: string
  screenXXL: string

  // Margin
  marginXXS: string
  marginXS: string
  marginSM: string
  marginBase: string
  marginMD: string
  marginLG: string
  marginXL: string
  marginXXL: string

  // Padding
  paddingXXS: string
  paddingXS: string
  paddingSM: string
  paddingBase: string
  paddingMD: string
  paddingLG: string
  paddingXL: string
  paddingMDCompact: string
  paddingXLCompact: string

  paddingContentHorizontalSM: string
  paddingContentVerticalSM: string
  paddingContentHorizontal: string
  paddingContentVertical: string
  paddingContentHorizontalLG: string
  paddingContentVerticalLG: string

  // Typography
  fontSizeBase: string
  fontSizeLG: string
  fontSizeSM: string
  fontSizeXS: string
  fontSizeXL: string
  fontSizeHeading1: string
  fontSizeHeading2: string
  fontSizeHeading3: string
  fontSizeHeading4: string
  fontSizeHeading5: string
  fontSizeIcon: string

  lineHeightBase: string
  lineHeightHeading1: string
  lineHeightHeading2: string
  lineHeightHeading3: string
  lineHeightHeading4: string
  lineHeightHeading5: string
  lineHeightLG: string
  lineHeightSM: string

  // Ant Design palette colors
  gold1: string
  gold2: string
  gold3: string
  gold4: string
  gold5: string
  gold6: string
  gold7: string
  gold8: string
  gold9: string
  gold10: string

  blue1: string
  blue2: string
  blue3: string
  blue4: string
  blue5: string
  blue6: string
  blue7: string
  blue8: string
  blue9: string
  blue10: string

  red1: string
  red2: string
  red3: string
  red4: string
  red5: string
  red6: string
  red7: string
  red8: string
  red9: string
  red10: string

  green1: string
  green2: string
  green3: string
  green4: string
  green5: string
  green6: string
  green7: string
  green8: string
  green9: string
  green10: string

  // Additional primary colors
  volcano1: string
  volcano2: string
  volcano3: string
  volcano4: string
  volcano5: string
  volcano6: string
  volcano7: string
  volcano8: string
  volcano9: string
  volcano10: string

  orange1: string
  orange2: string
  orange3: string
  orange4: string
  orange5: string
  orange6: string
  orange7: string
  orange8: string
  orange9: string
  orange10: string

  yellow1: string
  yellow2: string
  yellow3: string
  yellow4: string
  yellow5: string
  yellow6: string
  yellow7: string
  yellow8: string
  yellow9: string
  yellow10: string

  lime1: string
  lime2: string
  lime3: string
  lime4: string
  lime5: string
  lime6: string
  lime7: string
  lime8: string
  lime9: string
  lime10: string

  cyan1: string
  cyan2: string
  cyan3: string
  cyan4: string
  cyan5: string
  cyan6: string
  cyan7: string
  cyan8: string
  cyan9: string
  cyan10: string

  geekblue1: string
  geekblue2: string
  geekblue3: string
  geekblue4: string
  geekblue5: string
  geekblue6: string
  geekblue7: string
  geekblue8: string
  geekblue9: string
  geekblue10: string

  purple1: string
  purple2: string
  purple3: string
  purple4: string
  purple5: string
  purple6: string
  purple7: string
  purple8: string
  purple9: string
  purple10: string

  magenta1: string
  magenta2: string
  magenta3: string
  magenta4: string
  magenta5: string
  magenta6: string
  magenta7: string
  magenta8: string
  magenta9: string
  magenta10: string
}

export interface UserSetting {
  theme?: Theme
}
